<template>
  <div
    class="probate-quiz-tool-question"
    :class="{
      'is-active': isActive,
      'is-special': question.type === 'multiselect',
    }"
  >
    <div class="probate-quiz-tool-question__inner">
      <div class="probate-quiz-tool-question__left">
        <div v-if="question.info" class="probate-quiz-tool-question__options-info">
          <bard :content="question.info" as-content />

          <details class="probate-quiz-tool-question__options-info-details">
            <summary class="probate-quiz-tool-question__options-info-summary">
              <span class="is-more">More details</span>
              <span class="is-hide">Hide details</span>
            </summary>
            <probate-quiz-tool-details :on-show="() => true" :details="question.details" />
          </details>
        </div>
        <div class="probate-quiz-tool-question__options">
          <template v-for="(option, index) in question.options" :key="`option-${index}`">
            <template v-if="option.type === 'card'">
              <probate-quiz-tool-option type="card" :option="option" :on-click="handleOption" :is-active="multipleAnswerIds.includes(option.id)" />
            </template>
            <template v-else-if="option.type === 'radio'">
              <probate-quiz-tool-option type="radio" :option="option" :on-click="handleOption" :is-active="multipleAnswerIds.includes(option.id)" />
            </template>
            <template v-else>
              <probate-quiz-tool-option
                v-if="showOption(option)"
                type="default"
                :option="option"
                :on-click="handleNext"
                :is-active="option.id === answerId"
              />
            </template>
          </template>
        </div>
        <pt-button
          v-if="question.type === 'multiselect'"
          type="primary"
          size="extra-small"
          tag="button"
          wider
          :class="{
            'probate-quiz-tool-question__results-button': true,
            'is-disabled': multipleAnswerIds.length === 0,
          }"
          @click="handleShowResults"
        >
          Get Results
        </pt-button>
      </div>

      <div class="probate-quiz-tool-question__right">
        <div class="probate-quiz-tool-question__right-inner">
          <probate-quiz-tool-details :on-show="showDetails" :details="question.details" />

          <template v-for="(option, detailsIndex) in question.options" :key="`option-details-${detailsIndex}`">
            <probate-quiz-tool-details :on-show="() => option.id === answerId" :details="option.details" />
          </template>

          <template v-for="(details, detailsIndex) in question.range_details" :key="`option-range-details-${detailsIndex}`">
            <probate-quiz-tool-details :on-show="() => showRangeResultsIndex === detailsIndex" :details="details.details" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { LooseObject } from '~/types/generic';
import Bard from '~/components/content/Bard.vue';
import PtButton from '~/components/global/elements/PtButton.vue';
import { useProbateQuizTool } from '~/composables/probate-quiz-tool';

defineProps({
  question: {
    type: Object as () => LooseObject,
    required: true,
  },
  isActive: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const { answerId, currentQuestionIndex, questions, multipleAnswerIds, showRangeResultsIndex, next, finish, addMultipleAnswer, setShowResults } =
  useProbateQuizTool();

const handleNext = (option: LooseObject) => {
  if (option.type === 'continue') {
    next(option.next_step);
  }

  if (option.type === 'finish') {
    finish(option.id);
  }
};

const handleOption = (option: LooseObject, type: string) => {
  addMultipleAnswer(option.id, type);
};

const showOption = (option: LooseObject) => {
  if (option.type === 'continue') {
    return currentQuestionIndex.value < questions.value.length - 1;
  }

  return true;
};

const showDetails = () => {
  return !answerId.value && multipleAnswerIds.value.length === 0;
};

const handleShowResults = () => {
  setShowResults(true);

  const contentRef = document.querySelector('.block-probate-quiz-tool__quiz-header');
  if (contentRef) {
    contentRef.scrollIntoView({ behavior: 'smooth' });
  }
};
</script>
